import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_asn_order_tasks_grid_ComponentContextService } from './FootprintManager.asn_order_tasks_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Inventory_operationcodes_dd_multiComponent } from './Inventory.operationcodes_dd_multi.component'
import { Inventory_task_statuses_dd_multiComponent } from './Inventory.task_statuses_dd_multi.component'


import { FootprintManager_asn_order_children_tasks_gridComponent } from './FootprintManager.asn_order_children_tasks_grid.component';

interface IFootprintManager_asn_order_tasks_gridComponentEntity {
  Id?: number, ActualPackagedAmount?: number, ChainHead?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, ModifiedSysUser?: string, Notes?: string, SerialNumberId?: number, ActualPackagedPack?: { ShortName?: string }, ExpectedPackagedPack?: { ShortName?: string }, Lot?: { Id?: number, LookupCode?: string, Material?: { ProjectId?: number, Project?: { Id?: number, LookupCode?: string } } }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { Id?: number, LookupCode?: string } }, Project?: { Id?: number, LookupCode?: string }, OperationCode?: { Name?: string }, Status?: { Name?: string }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string }, ActualSourceLocation?: { Id?: number, Name?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string }, ActualTargetLocation?: { Id?: number, Name?: string }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string }, ExpectedTargetLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedTargetLocation?: { Id?: number, Name?: string }, Warehouse?: { Name?: string }, Order?: { LookupCode?: string, OwnerReference?: string, VendorReference?: string }, SerialNumber?: { LookupCode?: string }}

interface IFootprintManager_asn_order_tasks_gridComponentInParams {
  orderId: number, shipmentId: number}


class FootprintManager_asn_order_tasks_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_asn_order_tasks_gridComponent;
  entity: IFootprintManager_asn_order_tasks_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: null,
    warehouse: null,
    operation_code: null,
    status: null,
    material_lookupcode: null,
    lot: null,
    serialnumber: null,
    actual_packaged_amount: null,
    expected_packaged_amount: null,
    created_date: null,
    completed_date: null,
    user: null,
    actual_source_licenseplate: null,
    actual_source_location: null,
    actual_target_licenseplate: null,
    actual_target_location: null,
    expected_source_licenseplate: null,
    expected_source_location: null,
    expected_target_licenseplate: null,
    expected_target_location: null,
    notes: null,
  }


  //#region rowExpand inParams


  get $rowExpand_FootprintManager_asn_order_children_tasks_grid_inParams_taskId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.entity.Id;
    
    return expr;
  }
  //#endregion rowExpand inParams

  constructor(
    grid: FootprintManager_asn_order_tasks_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.operation_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.operation_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_lookupcode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material_lookupcode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.serialnumber = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.serialnumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.actual_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.expected_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.created_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.created_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.completed_date = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.completed_date,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.actual_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.actual_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_source_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_source_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_licenseplate = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_licenseplate,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.expected_target_location = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.expected_target_location,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.notes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.notes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_asn_order_tasks_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_asn_order_tasks_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      order_id:  $grid.inParams.orderId ,
      full_text_search:  $grid.fullTextSearch ,
      shipment_id:  $grid.inParams.shipmentId ,
      operation_code_ids:  $grid.filters.operation_code.control.value ,
      status_ids:  $grid.filters.status.control.value ,
    };
    const data = await this.$datasources.AsnOrders.ds_asn_orders_tasks_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_asn_order_tasks_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse.Name;
    (this.cells.operation_code.displayControl as TextModel).text = $row.entity.OperationCode?.Name;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.serialnumber.displayControl as TextModel).text = $row.entity.SerialNumber?.LookupCode;
    (this.cells.actual_packaged_amount.displayControl as TextModel).text = $utils.isDefined($row.entity.ActualPackagedAmount) ? $row.entity.ActualPackagedAmount?.toString() + ' ' + $row.entity.ActualPackagedPack?.ShortName : '';
    (this.cells.expected_packaged_amount.displayControl as TextModel).text = $utils.isDefined($row.entity.ExpectedPackagedAmount) ? $row.entity.ExpectedPackagedAmount?.toString() + ' ' + $row.entity.ExpectedPackagedPack?.ShortName : '';
    (this.cells.user.displayControl as TextModel).text = $row.entity.ModifiedSysUser;
    (this.cells.actual_source_licenseplate.displayControl as TextModel).text = $row.entity.ActualSourceLicensePlate?.LookupCode;
    (this.cells.actual_source_location.displayControl as TextModel).text = $row.entity.ActualSourceLocation?.Name;
    (this.cells.actual_target_licenseplate.displayControl as TextModel).text = $row.entity.ActualTargetLicensePlate?.LookupCode;
    (this.cells.actual_target_location.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.expected_source_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedSourceLicensePlate?.LookupCode;
    (this.cells.expected_source_location.displayControl as TextModel).text = $row.entity.ExpectedSourceLocation?.Name;
    (this.cells.expected_target_licenseplate.displayControl as TextModel).text = $row.entity.ExpectedTargetLicensePlate?.LookupCode;
    (this.cells.expected_target_location.displayControl as TextModel).text = $row.entity.ExpectedTargetLocation?.Name;
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'material_lookupcode' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'serialnumber' : {
        this.on_serialnumber_clicked();
        break;
      }
      case 'actual_source_licenseplate' : {
        this.on_actual_source_lp_clicked();
        break;
      }
      case 'actual_source_location' : {
        this.on_actual_source_location_clicked();
        break;
      }
      case 'actual_target_licenseplate' : {
        this.on_actual_target_lp_clicked();
        break;
      }
      case 'actual_target_location' : {
        this.on_actual_target_location_clicked();
        break;
      }
      case 'expected_source_licenseplate' : {
        this.on_expected_source_lp_clicked();
        break;
      }
      case 'expected_source_location' : {
        this.on_expected_source_location_clicked();
        break;
      }
      case 'expected_target_licenseplate' : {
        this.on_expected_target_lp_clicked();
        break;
      }
      case 'expected_target_location' : {
        this.on_expected_target_location_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  
  // Set Date/Time Formats
  const format = `${$settings.DockAppointments.DateFormat}, ${$settings.DockAppointments.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  
  if ($utils.isDefined($row.entity.CreatedSysDateTime) ) {
      $row.cells.created_date.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime , format);
  }
  
  
  if ($utils.isDefined($row.entity.CompletedDateTime) ) {
      $row.cells.completed_date.displayControl.text =  $utils.date.format($row.entity.CompletedDateTime , format);
  }
  
  
  
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.Material?.Id)) {
      $shell.FootprintManager.opensingle_material_hub({ materialId: $row.entity.Material.Id });
  }
  
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if($utils.isDefined($row.entity?.Lot?.Id))
  {
      $shell.FootprintManager.opensingle_lot_hub({lotId: $row.entity.Lot.Id});
  } 
  }
  on_actual_source_lp_clicked(event = null) {
    return this.on_actual_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_lp_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualSourceLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualSourceLicensePlate.Id });
  }
  }
  on_actual_target_lp_clicked(event = null) {
    return this.on_actual_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_lp_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualTargetLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ActualTargetLicensePlate.Id });
  }
  }
  on_expected_source_lp_clicked(event = null) {
    return this.on_expected_source_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_lp_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ExpectedSourceLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedSourceLicensePlate.Id });
  }
  }
  on_expected_target_lp_clicked(event = null) {
    return this.on_expected_target_lp_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_lp_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedTargetLicensePlate?.Id)) {
      $shell.FootprintManager.opensingle_licenseplate_hub({ licenseplateId: $row.entity.ExpectedTargetLicensePlate.Id });
  }
  }
  on_actual_source_location_clicked(event = null) {
    return this.on_actual_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_source_location_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualSourceLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualSourceLocation.Id });
  }
  }
  on_actual_target_location_clicked(event = null) {
    return this.on_actual_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_location_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ActualTargetLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ActualTargetLocation.Id });
  }
  }
  on_expected_source_location_clicked(event = null) {
    return this.on_expected_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_source_location_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.ExpectedSourceLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedSourceLocation.Id });
  }
  }
  on_expected_target_location_clicked(event = null) {
    return this.on_expected_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_expected_target_location_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.entity?.ExpectedTargetLocation?.Id)) {
      $shell.FootprintManager.opensingle_location_hub({ locationId: $row.entity.ExpectedTargetLocation.Id });
  }
  }
  on_serialnumber_clicked(event = null) {
    return this.on_serialnumber_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_serialnumber_clickedInternal(
    $row: FootprintManager_asn_order_tasks_gridComponentRowModel,
  $grid: FootprintManager_asn_order_tasks_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.SerialNumberId)) {
      $shell.FootprintManager.opensingle_serialnumber_hub({ serialnumberId: $row.entity.SerialNumberId });
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Inventory_operationcodes_dd_multiComponent),
    forwardRef(() => Inventory_task_statuses_dd_multiComponent),
    forwardRef(() => FootprintManager_asn_order_children_tasks_gridComponent)
  ],
  selector: 'FootprintManager-asn_order_tasks_grid',
  templateUrl: './FootprintManager.asn_order_tasks_grid.component.html'
})
export class FootprintManager_asn_order_tasks_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_asn_order_tasks_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_asn_order_tasks_gridComponentInParams = { orderId: null, shipmentId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'Id', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       operation_code: new GridHeaderModel(new HeaderStyles(null, null), 'operation_code', 'Operation code', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'material_lookupcode', 'Material', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', false, false, null, false),       serialnumber: new GridHeaderModel(new HeaderStyles(null, null), 'serialnumber', 'Serial number', false, false, null, false),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'actual_packaged_amount', 'Actual', false, false, null, false),       expected_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'expected_packaged_amount', 'Expected', false, false, null, false),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'created_date', 'Created date', false, false, null, false),       completed_date: new GridHeaderModel(new HeaderStyles(null, null), 'completed_date', 'Completed date', false, false, null, false),       user: new GridHeaderModel(new HeaderStyles(null, null), 'user', 'User', false, false, null, false),       actual_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_licenseplate', 'Actual source LP', false, false, null, false),       actual_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_source_location', 'Actual source loc', false, false, null, false),       actual_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_licenseplate', 'Actual target LP', false, false, null, false),       actual_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'actual_target_location', 'Actual target loc', false, false, null, false),       expected_source_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_licenseplate', 'Expected source LP', false, false, null, false),       expected_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_source_location', 'Expected source loc', false, false, null, false),       expected_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_licenseplate', 'Expected target LP', false, false, null, false),       expected_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'expected_target_location', 'Expected target loc', false, false, null, false),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'notes', 'Notes', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_asn_order_tasks_gridComponentRowModel[] = [];

  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('shipmentId') set $inParams_shipmentId(value: any) {
    this.inParams['shipmentId'] = value;
  }
  get $inParams_shipmentId(): any {
    return this.inParams['shipmentId'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    operation_code: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    operation_code: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['operation_code'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Operation code', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
  }

  //#region filters inParams
  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_asn_order_tasks_grid_ComponentContextService,
    ) {
    super();
    this.title = 'ASN order tasks';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.orderId)) {
        this.$missingRequiredInParams.push('orderId');
      }
      if(isNil(this.inParams.shipmentId)) {
        this.$missingRequiredInParams.push('shipmentId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      order_id:  $grid.inParams.orderId ,
      full_text_search:  $grid.fullTextSearch ,
      shipment_id:  $grid.inParams.shipmentId ,
      operation_code_ids:  $grid.filters.operation_code.control.value ,
      status_ids:  $grid.filters.status.control.value ,
    };
    try {
      const data = await this.$datasources.AsnOrders.ds_asn_orders_tasks_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_asn_order_tasks_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_asn_order_tasks_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
